import React, { useState } from 'react';
import {
  Button,
  Col,
  Form,
  Input,
  Row,
  Typography,
  Select,
  InputNumber,
  Collapse,
  Space
} from 'antd';

import '../Common/Form.css';

import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import ImageUploadSection from '../ImageUploadSection';
import { beforeImageUpload } from '../../utilities/imageUpload';

const { Text } = Typography;
const { Panel } = Collapse;
export const getSubunitKind = (record) => {
  for (const [key, value] of Object.entries(exerciseTypesMap)) {
    if (key in record) return value;
  }
};

export const exerciseTypesMap = {
  exerciseId: 'Exercise',
  videoId: 'Video',
  assignmentId: 'Assignment',
  certificateId: 'Certificate'
};

export const exerciseTypesMapReverse = {
  Exercise: 'exerciseId',
  Video: 'videoId',
  Assignment: 'assignmentId',
  Certificate: 'certificateId'
};

const exerciseOptions = [
  { label: 'Exercise', value: 'exercise' },
  { label: 'Resource', value: 'resource' },
  { label: 'Activity', value: 'activity' }
];

export const renderAditionalExerciseFieldsOnSubunitLevel = () => {
  return (
    <>
      <Form.Item
        label="Long Description"
        name="longDescription"
        rules={[
          {
            required: false, //not required, for now
            message: 'Please exercise subunit long description!'
          }
        ]}>
        <Input />
      </Form.Item>
      <Form.Item
        label="Icon link"
        name="icon"
        default="https://d2oi1rqwb0pj00.cloudfront.net/na-portal/ExerciseThumbnails/resources.png"
        rules={[
          {
            required: false
          }
        ]}>
        <Input placeholder="Default icon for exercise/resource will be set if not given" />
      </Form.Item>
    </>
  );
};
export const renderAdditionalExerciseForm = () => {
  return (
    <>
      <Form.Item
        label="Exercise Category"
        name="category"
        rules={[
          {
            required: false,
            message: 'default: Set exercise type'
          }
        ]}>
        <Select
          placeholder={'Default: Exercise'}
          defaultValue={'exercise'}>
          {exerciseOptions.map((option) => {
            return (
              <Select.Option value={option.value}>
                {option.label}
              </Select.Option>
            );
          })}
        </Select>
      </Form.Item>
      <Form.Item
        label="Exercise/Resource title"
        name="resource-exerciseTitle"
        rules={[
          {
            required: false
          }
        ]}>
        <Input placeholder="Default: exercise/resource title" />
      </Form.Item>
      <Form.Item
        label="Exercise/Resource description"
        name="resource-exerciseDescription"
        rules={[
          {
            required: false
          }
        ]}>
        <Input placeholder="Default: exercise/resource Description" />
      </Form.Item>
      <Form.Item
        label="Exercise/Resource longDesription"
        name="resource-exerciseLongDescription"
        rules={[
          {
            required: false
          }
        ]}>
        <Input placeholder="Default: exercise/resource LongDescription" />
      </Form.Item>
      <Form.Item label="file" name="file">
        <Form.Item
          label="name"
          name="fileName"
          rules={[
            {
              required: true
            }
          ]}>
          <Input placeholder="name of resource/exercise file" />
        </Form.Item>
        <Form.Item
          label="link"
          name="fileLink"
          rules={[
            {
              required: true
            }
          ]}>
          <Input placeholder="link of resource/exercise file" />
        </Form.Item>
      </Form.Item>
      <Form.Item
        label="Exercise Deadline Text"
        name="deadlineText"
        rules={[
          {
            required: false,
            message:
              'Please submit the deadline text to appear above-right exercise!'
          }
        ]}>
        <Input />
      </Form.Item>

      <Form.Item
        label="ctaBtnText"
        name="ctaBtnText"
        rules={[
          {
            required: false,
            message:
              'Please submit the ctaBtn text to appear above-right exercise/resource!'
          }
        ]}>
        <Input placeholder="Default: Download" />
      </Form.Item>
      <Form.Item
        label="ctaBtnIcon"
        name="ctaBtnIcon"
        rules={[
          {
            required: false,
            message:
              'Please submit the ctaIcon link to appear above-right exercise/resource!'
          }
        ]}>
        <Input placeholder="Default: Default Download icon" />
      </Form.Item>
    </>
  );
};
export const renderAditionalVideoFieldsOnSubunitLevel = () => {
  return (
    <>
      <Text>Video Segments! Refer to Timestamp sheet.</Text>
      <Form.List name="topics">
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name, fieldKey, ...restField }) => (
              <Space
                key={key}
                style={{ display: 'flex', marginBottom: 8 }}
                align="baseline">
                <Form.Item
                  {...restField}
                  name={[name, 'title']}
                  fieldKey={[fieldKey, 'title']}
                  rules={[
                    { required: true, message: 'Missing topic title' }
                  ]}>
                  <Input placeholder="topic title" />
                </Form.Item>
                <Form.Item
                  {...restField}
                  name={[name, 'startSecond']}
                  fieldKey={[fieldKey, 'startSecond']}
                  rules={[
                    { required: true, message: 'Missing startSecond' }
                  ]}>
                  <InputNumber placeholder="startSecond" />
                </Form.Item>
                <Form.Item
                  {...restField}
                  name={[name, 'thumbnailLink']}
                  fieldKey={[fieldKey, 'thumbnailLink']}
                  rules={[
                    { required: true, message: 'Missing thumbnailLink' }
                  ]}>
                  <Input placeholder="ThumbnailLink" />
                </Form.Item>
                <div className={'ant-space-item-icon'}>
                  <MinusCircleOutlined onClick={() => remove(name)} />
                </div>
              </Space>
            ))}
            <Form.Item>
              <Button
                type="dashed"
                onClick={() => add()}
                block
                icon={<PlusOutlined />}>
                Add field
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>
    </>
  );
};
export const renderAdditionalVideoForm = () => {
  return (
    <>
      <Form.Item
        label="link"
        name="link"
        rules={[
          {
            required: true
          }
        ]}>
        <Input placeholder="enter link!" />
      </Form.Item>
      <Form.Item
        label="hlsLink"
        name="hlsLink"
        rules={[
          {
            required: true
          }
        ]}>
        <Input placeholder="enter hls link!" />
      </Form.Item>
      <Form.Item
        label="thumbnailLink"
        name="thumbnailLink"
        rules={[
          {
            required: true
          }
        ]}>
        <Input placeholder="enter thumbnailLink!" />
      </Form.Item>
      <Form.Item
        label="duartion"
        name="duration"
        rules={[
          {
            required: false,
            message:
              'Please submit the deadline text to appear above-right exercise/resource!'
          }
        ]}>
        <InputNumber placeholder="enter duration of video!" />
      </Form.Item>
      <Form.List name="subtitles">
        {(subtitles, { add, remove }) => (
          <>
            {subtitles.map(({ key, name, fieldKey, ...restField }) => (
              <Space
                key={key}
                style={{ display: 'flex', marginBottom: 8 }}
                align="baseline">
                <Form.Item
                  {...restField}
                  name={[name, 'language']}
                  fieldKey={[fieldKey, 'language']}
                  rules={[
                    { required: true, message: 'Missing language' }
                  ]}>
                  <Input placeholder="language" />
                </Form.Item>
                <Form.Item
                  {...restField}
                  name={[name, 'label']}
                  fieldKey={[fieldKey, 'label']}
                  rules={[{ required: true, message: 'Missing label' }]}>
                  <Input placeholder="label" />
                </Form.Item>
                <Form.Item
                  {...restField}
                  name={[name, 'isDefault']}
                  fieldKey={[fieldKey, 'isDefault']}
                  rules={[
                    { required: true, message: 'Missing isDefault' }
                  ]}>
                  <Select>
                    <Select.Option value={true}>True</Select.Option>
                    <Select.Option value={false}>False</Select.Option>
                  </Select>
                </Form.Item>
                <Form.Item
                  {...restField}
                  name={[name, 'src']}
                  fieldKey={[fieldKey, 'src']}
                  rules={[
                    { required: true, message: 'Missing subtitle link' }
                  ]}>
                  <Input placeholder="subtitle link" />
                </Form.Item>

                <MinusCircleOutlined onClick={() => remove(name)} />
              </Space>
            ))}
            <Form.Item>
              <Button
                type="dashed"
                onClick={() => add()}
                block
                icon={<PlusOutlined />}>
                Add field
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>
    </>
  );
};

export const renderAdditionalCertificateForm = (form, setStatus, type) => {
  return (
    <>
      {type === 'Add' && (
        <Form.Item
          label="Certificate Type"
          name="certificateType"
          rules={[
            { required: true, message: 'Please certificate Type!' }
          ]}>
          <Select
            onChange={(e) => {
              console.log(e);
            }}
            placeholder={'Select Subunit Type'}>
            <Select.Option value={'cohortondemandCertificate'}>
              Cohort Ondemand Certificate
            </Select.Option>
            <Select.Option value={'cohortliveCertificate'}>
              Cohort Live Certificate
            </Select.Option>
            <Select.Option value={'freeworkshopCertificate'}>
              Free Workshop Certificate
            </Select.Option>
          </Select>
        </Form.Item>
      )}
      <Collapse>
        <Panel header="Certificate Image (M:272x182, D:240x160)" key="2">
          <section>
            <ImageUploadSection
              beforeImageUpload={beforeImageUpload}
              nest={['imgData']}
              path={`na-portal/CertificateThumbnails/`}
              bucket={'image-assets.nasdaily.com'}
              setStatus={setStatus}
              form={form}
              imgRequired={{ mobile: true, desktop: true }}
              hideResolution={{ mobile: false, dekstop: false }}
              showWebP={true}
            />
          </section>
        </Panel>
      </Collapse>
    </>
  );
};
